import { Env } from "../../../index";
import { ResourcesCatalog } from "../../classes/resource/Resource";
import r001ResourceProd from "./prod/r001";

const prodResources = new ResourcesCatalog({
	resources: [r001ResourceProd],
});

const resources = (env: Env) => {
	switch (env) {
		case Env.STAGE:
			return prodResources;
		default:
			return prodResources;
	}
};

export { resources };
